/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class SystemManagerActionNames {
  static GetVisibleInvisibleSystems = (): string => '[System Manager] GetVisibleInvisibleSystems';

  static GetVisibleInvisibleSystemsSuccess = (): string => '[System Manager] GetVisibleInvisibleSystems Success';

  static GetReturnCodeAfterExport = (): string => '[System Manager] GetReturnCodeAfterExport';

  static GetReturnCodeAfterExportSuccess = (): string => '[System Manager] GetReturnCodeAfterExport Success';

  static BrowseClick = (): string => '[System Manager] BrowseClick';
  
  static BrowseClickSuccess = (): string => '[System Manager] BrowseClick Success';
  
  static onSystemManagerItemClickAction = (): string => '[System Manager] onSystemManagerItemClickAction';

  static onSystemManagerItemClickActionSuccess = (): string => '[System Manager] onSystemManagerItemClickAction success';
}
